export const hrefPrefix =
  process.env.NODE_ENV === "production" ? "" : "http://localhost:5031";
